<div style="width: 500px; height: 500px;" data-cy="person-select-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="person-select-header-section">
      <div class="section-header-title" data-cy="person-select-title-text">
        <ng-container *ngIf="data.mode === 'user'">Select Users</ng-container>
        <ng-container *ngIf="data.mode === 'patient'">Select Patient</ng-container>
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden;" data-cy="person-select-content-section">
      <app-tdo-search placeholder="Search patient" (searchCleared)="onSearchCleared($event)" (searchChange)="onSearchChange($event)" data-cy="person-select-search"></app-tdo-search>
      <div style="flex: 1; overflow-y: auto; max-height: 90%;" data-cy="person-select-list-container">
        <ng-container *ngIf="data.mode === 'user'">
          <div *ngFor="let user of filteredUsers" (click)="onUserSelect(user)" class="internal-messaging-person-select-item" [ngClass]="{'internal-messaging-person-select-item-selected': isUserItemSelected(user)}" data-cy="person-select-user-item">
            {{user.UserName}}
          </div>
        </ng-container>
        <ng-container *ngIf="data.mode === 'patient'">
          <div *ngFor="let patient of filteredPatients" (click)="onPatientSelect(patient)" class="internal-messaging-person-select-item" [ngClass]="{'internal-messaging-person-select-item-selected': isPatientItemSelected(patient)}" data-cy="person-select-patient-item">
            <div style="flex-basis: 50px; max-width: 50px; overflow-x: hidden;" data-cy="person-select-patient-number">{{patient.PatientNO}}</div>
            <div style="flex: 1;" data-cy="person-select-patient-firstname">{{patient.dataContact.FirstName}}</div>
            <div style="flex: 1;" data-cy="person-select-patient-midname">{{patient.dataContact?.MidName}}</div>
            <div style="flex: 1;" data-cy="person-select-patient-lastname">{{patient.dataContact.LastName}}</div>
          </div>
        </ng-container>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 40px; min-height: 40px;" data-cy="person-select-footer-section">
      <div style="flex: 1; margin-right: 6px; padding-top: 12px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="person-select-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="person-select-ok-button">Ok</button>
    </div>
  </div>
</div>
